import { render, staticRenderFns } from "./jamkbm.vue?vue&type=template&id=423c6948&"
import script from "./jamkbm.vue?vue&type=script&lang=js&"
export * from "./jamkbm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports